import { render, staticRenderFns } from "./MessageTypes.vue?vue&type=template&id=cf5c2770&"
import script from "./MessageTypes.vue?vue&type=script&lang=ts&"
export * from "./MessageTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports